import React, { useState } from 'react';
import { useAtomValue } from 'jotai';
import Grid from '@mui/material/Grid';
import lzSCommonsFormErrorsAtom from '@lz-atoms/Commons/formErrors';
import useLzFApiCall from '@lz/services/Api';
import { useLzOnMount } from '@lz/services/Hooks';
import { lzFShowSuccessMessage } from '@lz/services/Utils';
import LzSApp from '@lz/app/App';
import { LzTFormSizes } from '@lz/typings/types';
import LzXSpinner from '@lz/components/commons/Spinner';
import LzXForm from '../../../forms/Form';
import LzMBase from '@lz/models/commons/Base';
import LzMUser from '@lz/models/commons/User';
import LzXInputField from '../../../forms/fields/InputField';
import LzXStaticField from '../../../forms/fields/StaticField';

export interface LzPPageProfile {
  className?: string;
  style?: React.CSSProperties;
  formSize?: LzTFormSizes;
  children?: React.ReactNode;
}

const LzXPageProfile = (props: LzPPageProfile) => {
  const [profileData, setProfileData] = useState<LzMBase>(
    LzMBase.buildModel({}, LzMUser)
  );

  const lzApiCall = useLzFApiCall();

  const load = async () => {
    const data = await lzApiCall('profile');

    if (data) {
      setProfileData(data);
    }
  };

  const formErrorsState = useAtomValue(lzSCommonsFormErrorsAtom);

  const handleFormSubmit: React.FormEventHandler<HTMLFormElement> = async (
    event: React.FormEvent<HTMLFormElement>
  ) => {
    event.preventDefault();
    const data = await lzApiCall('profile', profileData, 'post');
    if (data) {
      lzFShowSuccessMessage('Record updated successfully!');
      return true;
    }
    return false;
  };

  const handleInputChange = (key: string, value: any) => {
    const updated = Object.assign({}, profileData);
    updated[key] = value;
    setProfileData(updated);
  };

  // Call only for the first time when component is initially loaded
  useLzOnMount(() => {
    load();
  });

  return (
    <LzSApp.WrapperTemplate private screenTitle='Update Profile'>
      {profileData ? (
        <React.Fragment>
          {props.children ? (
            props.children
          ) : (
            <div
              className={
                'lz-form-page lz-form-page-full lz-form-page-no-top-margin'
              }
            >
              <LzXForm
                submitLabel='Save Profile'
                onSubmit={handleFormSubmit}
                cancelLabel='Reload'
                onCancel={load}
              >
                <Grid container spacing={2}>
                  <Grid size={{ sm: 6, md: 4 }}>
                    <LzXStaticField
                      fluid
                      label='Email Addresss'
                      value={profileData.email}
                    />
                  </Grid>

                  <Grid size={{ sm: 6, md: 4 }}>
                    <LzXInputField
                      fluid
                      required
                      label='Full Name'
                      placeholder='enter your full name'
                      name='name'
                      value={profileData.name}
                      onChange={handleInputChange}
                      formErrors={formErrorsState}
                    />
                  </Grid>

                  <Grid size={{ sm: 6, md: 4 }}>
                    <LzXInputField
                      fluid
                      label='Phone No.'
                      placeholder='enter your phone number'
                      name='phone'
                      value={profileData.phone}
                      onChange={handleInputChange}
                      formErrors={formErrorsState}
                    />
                  </Grid>
                </Grid>
              </LzXForm>
            </div>
          )}
        </React.Fragment>
      ) : (
        <LzXSpinner />
      )}
    </LzSApp.WrapperTemplate>
  );
};

export default LzXPageProfile;
